<template>
  <v-btn small text v-on="$listeners">
    <v-icon left>mdi-table</v-icon>
    {{ $t("widgets.common.showTable") }}
  </v-btn>
</template>

<script>
export default {};
</script>

<style></style>
